import moment from 'moment';

const useTimeCalculation = () => {
  const calculateEndTime = (startTime, workHours, lunchTime = '0', imputableColation = false) => {
    const totalWorkDuration = moment.duration(workHours);
    const collationDuration = moment.duration(lunchTime, 'minutes');

    // Solo agregamos el tiempo de colación si imputableColation es true
    const totalDuration = imputableColation
      ? totalWorkDuration
      : moment.duration(totalWorkDuration).add(collationDuration);

    const start = moment.utc(startTime, 'HH:mm');
    const end = moment
      .utc(start)
      .add(totalDuration)
      .format('HH:mm');

    return end;
  };

  return { calculateEndTime };
};

export default useTimeCalculation;
